import { Box, Button } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LibraryContainer = styled(Box)`
  width: 100%;

  /* White page header over the canvas-coloured body, as on SSM and ACA. */
  html[data-theme='light'] & > .header-container {
    background: ${theme.colors.surfaceContainerBackground};
  }
`

export const LoadingWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${theme.spacing.xLarge}px;
`

export const ToolbarWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: ${theme.spacing.small}px;

  .line {
    display: flex;
    align-items: center;
    gap: 64px;

    @media (max-width: 1400px) {
      gap: ${theme.spacing.small}px;
    }
  }
`

export const LibraryContentWrapper = styled(Box)`
  height: auto;
  padding-left: 100px;
  padding-top: ${theme.spacing.small}px;
  z-index: 10;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;

  @media (min-width: 1280px) {
    padding-left: 0;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
  }
`

export const SelectorsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.medium}px;
  z-index: 10;

  @media (max-width: 1360px) {
    gap: ${theme.spacing.md}px;
  }
`

export const ResultsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.medium}px;
  flex-shrink: 0;

  @media (min-width: 1280px) {
    padding: 0;
  }

  .results-text {
    color: ${theme.colors.calendarDay};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    z-index: 10;
    white-space: nowrap;
  }
`

export const ListWrapper = styled(Box)`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin-bottom: ${theme.spacing.small}px;
  width: 920px;

  @media (min-width: 1280px) {
    justify-content: flex-start;
  }

  .no-underline {
    text-decoration: none;
  }
`

export const EmptyList = styled(Box)`
  display: flex;
  justify-content: center;
  flex-flow: column wrap;
  width: 100%;
  z-index: 10;

  .heading {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.huge};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 52px;
    margin-bottom: ${theme.spacing.medium}px;
  }

  .MuiButton-root {
    width: fit-content !important;
    font-weight: ${theme.typography.fontWeight.bold} !important;
  }
`

export const EmptyLogo = styled(Box)`
  position: fixed;
  bottom: -5px;
  right: 0;
  z-index: 1;

  svg {
    z-index: 1;

    path {
      fill: ${theme.colors.borderLow};
    }
  }
`

export const LoadingContainer = styled(Box)`
  display: flex;
  width: 920px;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.medium}px;
  flex-flow: column wrap;
`

export const ClearFilters = styled(Button)`
  background: transparent;
  border-radius: ${theme.attributes.borderRadius.secondary};
  gap: ${theme.spacing.xSmall}px;
  min-width: 78px;
  height: 32px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.thin};
  line-height: normal;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  text-transform: none;
  z-index: 10;
  color: ${theme.colors.cta} !important;

  svg path {
    fill: currentColor;
  }

  &.Mui-disabled {
    color: ${theme.colors.btnSecondaryDisabledText} !important;
  }
`
